import { ValidateResult } from 'aurelia-validation';

export class BreezeValidator {

  validateObject(object: any) {
    if (object.entityAspect.validateEntity()) {
      return [];
    }
    return object.entityAspect
      .getValidationErrors()
      .map(({ errorMessage, propertyName, key }:
        { errorMessage: string, propertyName: string, key: string }) =>
        new ValidateResult(key, object, propertyName, false, errorMessage));
  }

  validateProperty(object: any, propertyName: any) {
    if (object.entityAspect.validateProperty(propertyName)) {
      return [];
    }
    return object.entityAspect
      .getValidationErrors(propertyName)
      .map(({ errorMessage, propertyName, key }:
        { errorMessage: string, propertyName: string, key: string }) =>
        new ValidateResult(key, object, propertyName, false, errorMessage));
  }
}
